import { DialogContent } from '@/view/components/ui/dialog'
import { Separator } from '@/view/components/ui/separator'
import { useLiveFormContext } from '../../providers/LiveFormProvider'
import { AlertStep } from './AlertStep'
import { DataStep } from './DataStep'

export const LiveForm = () => {
  const { step } = useLiveFormContext()

  const steps = {
    0: <AlertStep />,
    1: <DataStep />,
  }

  const current = steps[step as keyof typeof steps]

  return (
    <DialogContent className="flex w-[492px] flex-col gap-0 rounded-3xl">
      <h1 className="mb-2 text-2xl font-semibold">Nova Transmissão</h1>
      <Separator />
      {current}
    </DialogContent>
  )
}
